<script setup>

const props = defineProps({
  extras: {
    type: Array,
    default: () => [],
  }
});

const model = defineModel({
  type: Array,
  default: () => [],
});

const selected = (extra) => {
  return model.value.some(item => item.id === extra.id);
}

const remove = (extra) => {
  const index = model.value.findIndex(item => item.id === extra.id);
  if (index !== -1) {
    model.value.splice(index, 1);
  }
}

const select = (extra) => {
  model.value.push({
    id: extra.id,
    name: extra?.rezdyName ?? extra.name,
    quantity: 1,
  })
}

</script>

<template>
  <div v-for="extra in extras">
    <div class="mt-10 lg:mt-20 p-10 pb-14 relative rounded-lg bg-light overflow-hidden">
      <div class="mb-8">
        <span class="inline-flex text-mdx font-semibold p-2 px-4 leading-none bg-primary rounded-full uppercase">
          Extras
        </span>
      </div>
      <h2 v-text="extra.name"
          class="font-bold text-xl lg:text-3xl text-dark mb-4"></h2>
      <div
          class="mb-4 text-dark text-xl"
          v-text="extra.description"
      ></div>

      <button
          v-if="!selected(extra)"
          class="flex justify-center items-center gap-2 font-semibold text-xlx w-full"
          @click.prevent="select(extra, true)"
      >
        <span v-text="extra.button"></span>
        <span class="bg-primary text-dark h-12 w-12 rounded-full flex items-center justify-center">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 1.5V6H12.5C13.0312 6 13.5 6.46875 13.5 7C13.5 7.5625 13.0312 8 12.5 8H8V12.5C8 13.0625 7.53125 13.5 7 13.5C6.4375 13.5 6 13.0625 6 12.5V8H1.5C0.9375 8 0.5 7.5625 0.5 7C0.5 6.46875 0.9375 6 1.5 6H6V1.5C6 0.96875 6.4375 0.5 7 0.5C7.53125 0.5 8 0.96875 8 1.5Z"
                    fill="currentColor" />
          </svg>
        </span>
      </button>

      <button
          v-if="selected(extra)"
          class="button bg-red-600 rounded-full text-white"
          @click.prevent="remove(extra)"
      >
        Remove extra
      </button>

      <img class="absolute scale-110 -bottom-[11px] left-0 w-full" :src="`${$settings.theme_url}/assets/images/wave-bottom-block.svg`" alt="Ochre wave">
    </div>
  </div>
</template>
